export default __webpack_public_path__ + "assets/tot-x.4468e983.svg";